import { useFeatureFlagEnabled } from 'posthog-js/react';

import GroupedSelect from '@/components/GroupedSelect';
import { dateFormatOptions } from '@/constants/constants';
import { PERSONALIZATION_FLAG } from '@/constants/featureFlags';
import AppVersion from '@/pages/Profile/AppVersion';
import usePreferences from '@/pages/Profile/Preferences/usePreferences';
import Terms from '@/pages/Profile/Terms';
import TokenGenerationComponent from '@/pages/Profile/TokenGeneration';

const Preferences = () => {
  const {
    timezone,
    changeUserSetting,
    dateFormat,
    timezoneOptions,
    marketsOptions,
    defaultMarket,
    terms,
    homepage,
    homepageOptions
  } = usePreferences();

  const isPersonalizationEnabled = useFeatureFlagEnabled(PERSONALIZATION_FLAG);

  return (
    <>
      <GroupedSelect
        label='Timezone'
        options={timezoneOptions}
        value={timezone.value}
        onChange={userSetting => {
          changeUserSetting('timezone', userSetting);
        }}
      />
      <GroupedSelect
        label='Date Format'
        options={dateFormatOptions}
        value={dateFormat.value}
        onChange={userSetting => {
          changeUserSetting('dateFormat', userSetting);
        }}
      />
      {isPersonalizationEnabled && (
        <GroupedSelect
          label='Homepage'
          options={homepageOptions}
          value={homepage.value}
          onChange={userSetting => {
            changeUserSetting('homepage', userSetting);
          }}
        />
      )}
      {!isPersonalizationEnabled && (
        <GroupedSelect
          label='Default Market'
          options={marketsOptions}
          value={defaultMarket.value}
          onChange={userSetting => {
            changeUserSetting('defaultMarket', userSetting);
          }}
        />
      )}

      <TokenGenerationComponent />
      <Terms termsSignedDate={terms} />
      <AppVersion />
    </>
  );
};

export default Preferences;
